import React from 'react';
import MuiCollapse, {
  CollapseProps as CollapseProperties,
} from '@mui/material/Collapse';
import MuiList, { ListProps as MUIListProperties } from '@mui/material/List';
import MuiListItem, {
  ListItemProps as MUIListItemProperties,
} from '@mui/material/ListItem';
import MuiListItemText, {
  ListItemTextProps as ListItemTextProperties,
} from '@mui/material/ListItemText';
import MuiListItemIcon, {
  ListItemIconProps as ListItemIconProperties,
} from '@mui/material/ListItemIcon';
import MuiListItemAvatar, {
  ListItemAvatarProps as ListItemAvatarProperties,
} from '@mui/material/ListItemAvatar';
import styled from '@emotion/styled';

const ListContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

type ListProperties = Component.Properties<MUIListProperties & {
  resetpadding?: boolean;
}>;

const List = ({
  tag,
  resetpadding,
  ...properties
}: ListProperties) => (
  <MuiList
    component={tag ?? 'ul'}
    disablePadding={resetpadding ?? false}
    {...properties}
  />
);

type ListItemProperties = Component.Properties<MUIListItemProperties> & {
  showDivider?: boolean;
};

const ListItem = ({
  tag,
  showDivider,
  ...properties
}: ListItemProperties) => (
  <MuiListItem
    component={tag ?? 'li'}
    divider={showDivider}
    {...properties}
  />
);

const ListItemText = (
  properties: ListItemTextProperties,
) => <MuiListItemText {...properties} />;

const ListItemMeta = (
  properties: ListItemIconProperties,
) => <MuiListItemIcon {...properties} />;

const CollapsibleList = React.forwardRef<HTMLElement, CollapseProperties>(
  (properties, reference) => <MuiCollapse {...properties} ref={reference} />,
);

const ListItemAvatar = (
  properties: ListItemAvatarProperties,
) => <MuiListItemAvatar {...properties} />;

export {
  List,
  ListItem,
  ListItemText,
  ListItemMeta,
  ListItemAvatar,
  CollapsibleList,
  ListContainer,
};
